import service from '@/plugins/request'

//获取游戏类型
export const getGameType = (params) => {
    return service({
        url: 'app/game/getGameType',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

//获取盒子游戏
export const getGame = (params) => {
    return service({
        url: 'api/client/game/getGame',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

//获取客服二维码
export const getServiceWechat = (data) => {
    return service({
        url: 'api/client/notice/getservicewechat',
        method: 'post',
        data,
        hideErrMsg: true
    })
}
//获取站点信息
export const getSiteInfo = (params) => {
    return service({
        url: 'api/client/notice/getSiteInfo',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

export const getMyActivity = (params) => {
    return service({
        url: 'api/client/notice/getActivity',
        method: 'get',
        params,
        hideErrMsg: true
    })
}